module.exports = __webpack_public_path__ + "media/images/flags/32/Venezuela-0944258e3ef3446d0f0cf2bb3d64d817.png";